import { useFetchRepairEventApi } from 'api/mypage/repair_event';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { MypageRouteHelper } from 'routes/mypage';
import { useEffectSkipFirst } from 'utils/hooks';

export const RepairEventShow: React.FC = () => {
  const globalState = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const fetchApi = useFetchRepairEventApi();

  useEffect(() => {
    fetchApi.execute(Number(id));
  }, []);

  useEffectSkipFirst(() => {
    globalState.setLoading(fetchApi.loading);
    if (fetchApi.isSuccess() && fetchApi.response.repairEvent.repairInfoId) {
      navigate(MypageRouteHelper.repairInfoShow(fetchApi.response.repairEvent.repairInfoId));
    }
  }, [fetchApi.loading]);

  return <></>;
};

export default RepairEventShow;
